"use client";

import Heading from "@afa-shared/afa-components/dist/Heading";
import Tag from "@afa-shared/afa-components/dist/Tag";
import Text from "@afa-shared/afa-components/dist/Text";
import { PressRelease } from "@clients/afaseApiClient";
import PhotoInfo from "@components/PhotoInfo/PhotoInfo";
import Grid from "@components/client/Grid";
import PageWrapper from "@containers/Layout/PageWrapper/PageWrapper";
import { defaultContext } from "@utils/contextHelper/getInitialContext";
import { formatPressReleaseDate, toDate } from "@utils/dateHelpers";
import { ImageType } from "@utils/imageHelpers/imageHelper";
import DOMPurify from "isomorphic-dompurify";

import { Context } from "types/context/Context";

import pressreleaseStyles from "./Pressrelease.module.css";

type PressReleasePageProps = {
  pressRelease: PressRelease;
};

const PressReleasePage = ({ pressRelease }: PressReleasePageProps) => {
  const mainImage = pressRelease?.mainImage
    ? pressRelease?.mainImage
    : pressRelease?.images
      ? pressRelease?.images?.[ImageType.metaImage] || pressRelease?.images?.[ImageType.mainImage]
      : null;

  const sanitizedBody = DOMPurify.sanitize(pressRelease?.body);
  const removeInlineStyleRegex = /( style=".+?")/gm;
  const cleanBody = sanitizedBody.replace(removeInlineStyleRegex, "");

  const context: Context = { ...defaultContext };

  const publishedDateArray = pressRelease?.publishDate
    ? [formatPressReleaseDate(toDate(pressRelease?.publishDate))]
    : [];

  return (
    <PageWrapper
      columns={8}
      context={context}
      useReCapcha={false}
      shouldRemoveBottomMargin={false}
      className={pressreleaseStyles.pressreleasePage}
    >
      <Grid desktop={8}>
        <Heading variant="h1">{pressRelease?.heading}</Heading>
        <div className={pressreleaseStyles.infoWrapper}>
          <Tag label="Pressmeddelande" />
          <div className={pressreleaseStyles.dateWrapper}>
            {publishedDateArray.map((item, index) => (
              <Text variant="span" key={index}>
                {item}
              </Text>
            ))}
          </div>
        </div>
        {pressRelease?.preamble && <Text variant={"preamble"} children={pressRelease?.preamble} />}

        {mainImage?.url && (
          <div className={pressreleaseStyles.imageWrapper}>
            <img src={mainImage.url} alt={mainImage?.caption} />
            <PhotoInfo description={pressRelease?.image_caption} />
          </div>
        )}
        <div
          className={pressreleaseStyles.body}
          dangerouslySetInnerHTML={{ __html: cleanBody }}
        ></div>
        {/* <PrintButton /> */}
      </Grid>
    </PageWrapper>
  );
};

export default PressReleasePage;
